import { createApiSlice } from "@common";
import {MY_INFO_ACCOUNT_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeAccountInfoType",
    method: "post",
    url:MY_INFO_ACCOUNT_CONFIG,
    stateKey: "message",
  },

  {
    name: "getEmployeeAccountInfoType",
    method: "get",
    url:MY_INFO_ACCOUNT_CONFIG,
    stateKey: "data",
  },

  {
    name: "updateEmployeeAccountInfoType",
    method: "put",
    url:MY_INFO_ACCOUNT_CONFIG,
    stateKey: "message",
  },

  {
    name: "deleteEmployeeAccountInfoType",
    method: "delete",
    url:MY_INFO_ACCOUNT_CONFIG,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("engagementLevel", apiConfig, customReducers);
const engagementLevelSlice = slice;

export default engagementLevelSlice.reducer;

export const {
  addEmployeeAccountInfoType,
  getEmployeeAccountInfoType,
  updateEmployeeAccountInfoType,
  deleteEmployeeAccountInfoType,
} = thunks;

export const { rowSelect } = actions;
